import React from "react";
import { Link } from "react-router-dom";
import ContainerCard from "./containerCard";
import { useMediaQuery } from "react-responsive";
import { useLocation } from "react-router-dom";
import { wordEllipsis } from "../../utils/strings";
import URI from "urijs";

export default function ArticleDataSection({ content }) {
  const location = useLocation();
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });
  const posts = content.blog_posts || content;
  if (!posts || posts.length === 0 || (content.onlyMobile && !isMobile)) return null;

  const articles = {
    name: "Related Articles",
    data: posts.map(e => ({
      linkTitle: "Read",
      path: new URI(location.pathname).segment(1, e.slug).pathname(),
      title: e.title
    }))
  };

  return (
    <div className="articleDataSection">
      <div className="name">{articles.name}</div>
      {articles.data.map((article, index) => (
        <ContainerCard key={index}>
          <div className="card">
            <div className="title">
              {isMobile ? <span>{wordEllipsis(article.title, 42)}</span> : <span>{article.title}</span>}
            </div>
            <Link to={article.path} className="buttonLink">
              <span>{article.linkTitle}</span>
            </Link>
          </div>
        </ContainerCard>
      ))}
    </div>
  );
}
